<template>
  <v-row class="position-banner">
    <v-col cols="3">
      <!-- <div class="h-100">
        <span class="text-title">Anchura</span>
        <input-number-generic v-model="width" :step="10" :disabled="!activeButtons"/>
      </div>
      <v-btn
      class="mt-6" 
        icon
        text
        @click="activeScaleOption = !activeScaleOption"
      >
      <v-icon :color="`${activeScaleOption ? 'primary' : ''}`"  size="16">$fi-link-2</v-icon>
    </v-btn>
      
      <div class="h-100">
        <span class="text-title">Altura</span>
        <input-number-generic v-model="height" :step="10" :disabled="!activeButtons" />
      </div> -->
      <span class="text-title">{{$t('general.escalar')}}</span>
      <div class="d-flex align-center">
        <cotizador-btn
          class="mr-2"
          :class="{active: incrementoAcumulado > 0}"
          content-class="px-3 flip-btn" :on="{
            click: () => scaleZoomBtn(1)
          }">
          <v-icon :color="`${incrementoAcumulado > 0 ? 'primary' : ''}`"  class="mr-1" size="16">$fi-maximize-2</v-icon>
          <span class="text-btn">{{$t('general.aumentar')}}</span>
        </cotizador-btn>
        <cotizador-btn
          content-class="px-3 flip-btn"
          :class="{active: incrementoAcumulado < 0}"
          :on="{
            click: () => scaleZoomBtn(-1)
          }">
          <v-icon :color="`${incrementoAcumulado < 0 ? 'primary' : ''}`" class="mr-1" size="16">$fi-minimize-2</v-icon>
          <span class="text-btn">{{$t('general.disminuir')}}</span>
        </cotizador-btn>
      </div>
    </v-col>
    <v-col cols="3">
      <span class="text-title">{{$t("general.voltear")}}</span>
      <div class="d-flex align-center">
        <cotizador-btn
          class="mr-2" 
          :class="{active: isFlipedX}"
          content-class="px-3 flip-btn" :on="{
            click: flipX
          }">
          <v-icon :color="`${isFlipedX ? 'primary' : ''}`" class="mr-1" size="16">$fi-flip-horizontal</v-icon>
          <span class="text-btn">{{$t("general.horizontal")}}</span>
        </cotizador-btn>
        <cotizador-btn
          content-class="px-3 flip-btn"
          :class="{active: isFlipedY}"
          :on="{
            click: flipY
          }">
          <v-icon :color="`${isFlipedY ? 'primary' : ''}`" class="mr-1" size="16">$fi-flip-vertical</v-icon>
          <span class="text-btn">{{$t("general.vertical")}}</span>
        </cotizador-btn>
      </div>
    </v-col>
    <v-col cols="6">
      <span class="text-title">{{$t("general.girar")}}</span>
      <div class="d-flex align-center">
        <v-slider
          v-model="slider"
          max="360"
          min="0"
          step="5"
          track-color="black"
          color="black"
          thumb-color="primary"
          thumb-label
          hide-details
          :disabled="!activeButtons"
          @mouseup="rotate(slider)"
        ></v-slider>
        <input-number-generic
          v-model="slider"
          class="angle-input-slider"
          :disabled="!activeButtons"
          angle-mode
          @input="rotate(slider)"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { flipLogoX, flipLogoY, isFlipLogo, rotateLogo, scaleLogo, calcularIncrementoEscala } from "@/utils/customDimUtils";

import CotizadorBtn from "@/components/basic/CotizadorBtn.vue";
import InputNumberGeneric from "@/components/basic/InputNumberGeneric.vue";

export default {
  components: {
    CotizadorBtn,
    InputNumberGeneric
  },
  props: {
    img: {
      type: Object,
      required: true
    },
    zona: Object
  },
  data() {
    return {
      slider: 0,
      width: 0,
      height: 0,

      isFlipedX: false,
      isFlipedY: false,

      debounceFlipX: null,
      debounceFlipY: null,
      debounceSlider: null,
      debounceScale: null,

      originalSliderValor: 0,

      activeScaleOption: true,
      actualScale: 1,
      originalWidth: 0,
      originalHeight: 0,

      incrementoAcumulado: 0
    };
  },
  computed: {
    ...mapGetters("design", ["imgInfoCanvas3d", "actualListDesign", "activeZone3D", "rotateDesignState"]),
    actualImg3D() {
      let imgActual = this.actualListDesign.find(
        img => img.idImg == this.img.id
      )?.idImg;

      if (!imgActual) {
        console.warn(
          "💻 ~ No hemos podido encontrar la imagen para procesar su tamaño",
          imgActual
        );
        return;
      }

      // Obtenemos información 3D de la imagen
      let info3dImg = this.imgInfoCanvas3d[imgActual];

      if (!info3dImg) {
        console.warn(
          "💻 ~ No hemos podido encontrar la imagen para procesar su tamaño",
          imgActual
        );
        return;
      }
      
      return {...info3dImg, idDesign: imgActual };
    },
    activeButtons() {
      return this.activeZone3D && this.imgInfoCanvas3d;
    },
    rotateImg() {
      if (!this.actualImg3D?.idDesign) {
        console.warn(
          "💻 ~ No hemos podido encontrar la imagen para procesar su tamaño",
          this.actualImg3D?.idDesign
        );
        return 0;
      }

      return this.rotateDesignState[this.actualImg3D.idDesign];
    }
  },
  watch: {
    img(newValue) {
      console.log("WATHER img", newValue);
    },
    rotateImg: {
      handler(newValue, oldValue) {
        if (newValue != oldValue) {
          this.slider = newValue;
          this.originalSliderValor = newValue;
        }
      },
      immediate: true
    },
    actualImg3D: {
      async handler(newValue) {
        if (newValue && !isNaN(Number(newValue.width)) && !isNaN(Number(newValue.height))) {
          this.width = Math.ceil(Number(newValue.width) * newValue.scale);
          this.height = Math.ceil(Number(newValue.height) * newValue.scale);
          this.originalWidth = Number(newValue.width);
          this.originalHeight = Number(newValue.height);
          this.actualScale = newValue.scale;
        } else {
          this.width = 0;
          this.height = 0;
          this.originalWidth = 0;
          this.originalHeight = 0;
          this.actualScale = 1;
        }

        if (newValue && this.activeZone3D) {
          this.isFlipedX = await isFlipLogo(newValue, this.activeZone3D, "X");
          this.isFlipedY = await isFlipLogo(newValue, this.activeZone3D, "Y");
        }
      },
        deep: true,
        immediate: true
    },
   async width(newValue, oldValue) {
      if (!this.activeButtons) {
        console.warn("No se puede hacer scale, no hay imagen activa");
        return;
      }

     if (newValue == oldValue) {
        console.warn("No se puede hacer scale, no hay incremento valido", newValue, oldValue);
        return
     }
      
     if (!oldValue) {
        console.warn("No se puede hacer scale, no proviene de un tamaño válido", oldValue);
        return
     }

     if (this.activeScaleOption) {
        await this.inputSize(newValue, 'width');
      }
    },
    async height(newValue, oldValue) {
      if (!this.activeButtons) {
        console.warn("No se puede hacer scale, no hay imagen activa");
        return;
      }

     if (newValue == oldValue) return
      
     if(!oldValue) return

     if (this.activeScaleOption) {
        await this.inputSize(newValue, 'height');
      }
    },
  },
  methods: {
    ...mapActions('design', ['rotateLogoState']),
    /**
     * Invierte la orientación horizontal (flipX) de la imagen activa.
     * Usa debounce para evitar múltiples ejecuciones consecutivas.
     */
    async flipX() {
      if (!this.activeButtons) {
        console.warn("No se puede hacer flipX, no hay imagen activa");
        return;
      }

      if (this.debounceFlipX) {
        clearTimeout(this.debounceFlipX);
      }

      this.debounceFlipX = setTimeout(async () => {
        this.isFlipedX = !this.isFlipedX;
        await flipLogoX(this.actualImg3D, this.activeZone3D);
      }, 300);
    },
    /**
     * Invierte la orientación vertical (flipY) de la imagen activa.
     * Usa debounce para evitar múltiples ejecuciones consecutivas.
     */
    async flipY() {
      if (!this.activeButtons) {
        console.warn("No se puede hacer flipY, no hay imagen activa");
        return;
      }

      if (this.debounceFlipY) {
        clearTimeout(this.debounceFlipY);
      }
      this.debounceFlipY = setTimeout(async () => {
        this.isFlipedY = !this.isFlipedY;
        await flipLogoY(this.actualImg3D, this.activeZone3D);
      }, 500);
    },
    /**
     * Rota la imagen 3D activa según un ángulo dado.
     *
     * @param {number} grade - Ángulo en grados (-360 a 360).
     * @returns {void}
     *
     * Valida imagen activa y ángulo válido. Usa debounce para evitar llamadas excesivas.
     */
    async rotate(grade) {
      if (!this.activeButtons) {
        console.warn("No se puede hacer rotate, no hay imagen activa");
        return;
      }

      if (grade > 360 || grade < -360) {
        console.warn("No se puede hacer rotate");
        return;
      }

      if (this.debounceSlider) {
        clearTimeout(this.debounceSlider);
      }

      this.debounceSlider = setTimeout(async () => {
        let incremento = grade - this.originalSliderValor;

        if (incremento == 0 || isNaN(incremento)) return;

        await rotateLogo(this.actualImg3D, this.activeZone3D, Number(incremento));
        this.originalSliderValor = grade;

        this.rotateLogoState({
          rotate: grade,
          zone: this.zona,
          img: this.imgInfoCanvas3d[this.actualImg3D.idDesign],
          id: this.actualImg3D.idDesign
        })
      }, 600);
    },
    /**
     * Escala la imagen al tamaño deseado.
     * 
     * @param {number} size - Tamaño deseado.
     * @param {string} type - Dimensión ('width' o 'height').
     * 
     * @returns {Promise<void>}
     */
    async inputSize(size, type) {
      if (!this.activeButtons) {
      console.warn("No se puede hacer scale, no hay imagen activa");
      return;
      }

      if (this.debounceScale) {
        clearTimeout(this.debounceScale);
      }

      this.debounceScale = setTimeout(async () => {
        let originalSize = 0;
        if (type == 'width') {
          originalSize = this.originalWidth;
        } else if (type == 'height') {
          originalSize = this.originalHeight;
        } else {
          console.warn("No se puede hacer scale, tipo no válido");
          return;
        }

        console.error("Si se vuelve a añadir, revisar el step con los logos")

        // Hacemos el calculo del incremento de escala que tenemos que hacer, para obtener el tamaño indicado
        let incremento = calcularIncrementoEscala(
          originalSize,
          this.actualScale,
          size,
        );

        if (incremento == 0 || isNaN(incremento) || !isFinite(incremento)) return;

        await this.scale(incremento);

        // Actualizar la escala actual correctamente
        this.actualScale = this.actualScale + incremento * 0.02;

        if (type == 'width') {
          this.height = Math.ceil(this.originalHeight * this.actualScale);
        } else if (type == 'height') {
          this.width = Math.ceil(this.originalWidth * this.actualScale);
        }
      }, 400);
    },
    
    /**
     * Ajusta el zoom de la imagen activa en función de un incremento dado.
     * @param {number} incremento - Valor del incremento para ajustar el zoom (por defecto 1).
     * @returns {void}
     */
    scaleZoomBtn(incremento = 1) {
      if (!this.activeButtons) {
        console.warn("No se puede hacer scaleZoomBtn, no hay imagen activa");
        return;
      }

      this.incrementoAcumulado += incremento;

      if (this.debounceScale) {
        clearTimeout(this.debounceScale);
      }

      this.debounceScale = setTimeout(async () => {
        await this.scale(this.incrementoAcumulado);
      }, 300);
    },
    /**
     * Escala la imagen 3D activa en la zona activa.
     *
     * @param {number} [incremento=1] - Factor de escala.
     * @returns {Promise<void>} - Promesa resuelta al completar.
     *
     * Verifica si hay imagen activa y parámetros válidos antes de usar `scaleLogo`.
     * Reinicia `incrementoAcumulado` tras la operación.
     */
    async scale(incremento = 1) {
      if (!this.activeButtons) {
        console.warn("No se puede hacer rotate, no hay imagen activa");
        return;
      }

      if (!incremento || isNaN(incremento) || !isFinite(incremento)) {
        console.warn("No se puede hacer scale, no hay incremento valido", incremento);
        return;
      }

      if(!this.actualImg3D) {
        console.warn("No se puede hacer scale, no hay imagen activa");
        return;
      }

      await scaleLogo(this.actualImg3D, this.activeZone3D, incremento);

      this.incrementoAcumulado = 0
    }
  }
};
</script>

<style scoped lang="scss">
.position-banner {
  .col {
    padding: 0 !important;

    &:not(:first-child) {
      padding-left: 2px !important;
    }
  }

  .text-btn,
  .text-title {
    color: var(--Color-Black, #121212);
    font-family: $heading-font-family;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    text-transform: capitalize;
  }

  .text-title {
    color: var(--Color-Grey-600, #787878);
  }

  :deep(.v-input__slider > .v-input__append-outer) {
    margin-bottom: 4px;
  }

  :deep(.flip-btn.v-btn) {
    border-radius: 4px !important;
    border: 1px solid var(--Color-Grey-300, #dcdcdc);
    background: var(--Color-White, #fff);
  }

   :deep(.active > .flip-btn.v-btn) {
      border: 1px solid var(--v-primary-base);
      background: var(--Color-Grey-100, #dcdcdc);
    }

  .angle-input-slider {
    width: fit-content;
  }
}
</style>
